"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubmitDifyLead = useSubmitDifyLead;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var _getVisitorGuid = require("../helpers/getVisitorGuid");
var _getHostname = require("../helpers/getHostname");
var _utils = require("./utils");
var _config = require("./config");
var _logger = _interopRequireDefault(require("./logger"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Type definitions

var API_HOOK_CAMPAIGN_NAME = 'API Hook Submission';

// YOHO-4013: commerce endpoint path; local literal (not imported from @redux) so loader/hooks stays app/redux-free.
var COMMERCE_LEAD_SUBMIT_PATH = 'api/v1/lead/dify';

/**
 * Fetch customer contact information from GoDaddy API
 * NOTE: assumes data from api will be valid so not checking validity of email, phone, etc.
 */
function fetchCustomerContact(_x, _x2) {
  return _fetchCustomerContact.apply(this, arguments);
}
/**
 * Fetch lead score from Lead Score API
 */
function _fetchCustomerContact() {
  _fetchCustomerContact = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(customerId, apiUrls) {
    var _customerData$contact, _customerData$contact2, _customerData$contact3, _customerData$contact4;
    var customerData, contact;
    return _regenerator.default.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _logger.default.info('Fetching customer contact', {
            customerId: customerId
          });
          _context3.next = 1;
          return (0, _utils.makeApiCall)("".concat(apiUrls.modalLoaderApi, "/api/v1/customer/").concat(customerId, "/shopper"));
        case 1:
          customerData = _context3.sent;
          contact = {
            fullName: "".concat(((_customerData$contact = customerData.contact) === null || _customerData$contact === void 0 ? void 0 : _customerData$contact.nameFirst) || '', " ").concat(((_customerData$contact2 = customerData.contact) === null || _customerData$contact2 === void 0 ? void 0 : _customerData$contact2.nameLast) || '').trim(),
            email: customerData.email || '',
            phoneNumber: ((_customerData$contact3 = customerData.contact) === null || _customerData$contact3 === void 0 ? void 0 : _customerData$contact3.phoneHome) || ((_customerData$contact4 = customerData.contact) === null || _customerData$contact4 === void 0 ? void 0 : _customerData$contact4.phoneWork) || ''
          };
          _logger.default.info('Customer contact fetched successfully', {
            customerId: customerId
          });
          return _context3.abrupt("return", contact);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchCustomerContact.apply(this, arguments);
}
function fetchLeadScore(_x3, _x4) {
  return _fetchLeadScore.apply(this, arguments);
}
/**
 * Build the complete lead payload
 */
function _fetchLeadScore() {
  _fetchLeadScore = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(leadSource, apiUrls) {
    var leadScoreData;
    return _regenerator.default.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _logger.default.info('Fetching lead score', {
            leadSource: leadSource
          });
          _context4.next = 1;
          return (0, _utils.makeApiCall)("".concat(apiUrls.leadScoreApi, "/v1/lead/score?leadSource=").concat(leadSource));
        case 1:
          leadScoreData = _context4.sent;
          _logger.default.info('Lead score fetched successfully', {
            score: leadScoreData.score
          });
          return _context4.abrupt("return", leadScoreData.score);
        case 2:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchLeadScore.apply(this, arguments);
}
function buildLeadPayload(contact, leadScore, params) {
  var queryParams = (0, _utils.getParsedQueryParams)();
  return _objectSpread(_objectSpread({
    // Lead Keys (Contact info, product intent, externalSystemId)
    fullName: contact.fullName,
    email: contact.email,
    phoneNumber: contact.phoneNumber,
    smsConsent: params.smsConsent,
    productIntent: params.productIntent,
    externalSystemId: params.externalSystemId
  }, params.recordOwnerEmail ? {
    recordOwnerEmail: params.recordOwnerEmail
  } : {}), {}, {
    // --- EXTERNALLY SET PROPS -----
    businessName: params.businessName,
    businessWebsite: params.businessWebsite,
    sourceApp: params.sourceApp,
    customerId: params.customerId,
    leadSource: params.leadSource,
    // --- INTERNALLY SET PROPS -----
    // Campaign tracking and other identifiers
    campaignName: API_HOOK_CAMPAIGN_NAME,
    campaignDetails: params.source,
    campaignId: queryParams.campaignId,
    visitorGuid: (0, _getVisitorGuid.getVisitorGuid)(),
    leadScore: leadScore,
    formSource: (0, _getHostname.getHostname)(),
    // UTM & Ad tracking from query params
    utmSource: queryParams.utmSource,
    utmMedium: queryParams.utmMedium,
    utmTerm: queryParams.utmTerm,
    utmContent: queryParams.utmContent,
    adClickId: queryParams.adClickId,
    adLeadId: queryParams.adLeadId
  });
}

/**
 * Submit lead payload to the lead-capture backend.
 *
 * Legacy path (default): POSTs to GUI/LMAPI and treats 400 responses as success
 * per existing behavior.
 *
 * Commerce path (YOHO-4013, opt-in): POSTs the SAME payload to
 * commerce-lead-capture-service /api/v1/lead/dify. That endpoint needs no
 * X-App-Key and reports validation failures as non-2xx, so we do NOT swallow
 * 400s here — `makeApiCall` throws on any error status and the hook reports it.
 */
function submitLeadToAPI(_x5, _x6, _x7) {
  return _submitLeadToAPI.apply(this, arguments);
}
function _submitLeadToAPI() {
  _submitLeadToAPI = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(payload, apiUrls, commerceLeadSubmissionEnabled) {
    var response, _response, _submitError$message, _t2;
    return _regenerator.default.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!commerceLeadSubmissionEnabled) {
            _context5.next = 2;
            break;
          }
          _logger.default.info('Submitting lead to commerce-lead-capture-service', {
            externalSystemId: payload.externalSystemId,
            customerId: payload.customerId
          });
          _context5.next = 1;
          return (0, _utils.makeApiCall)("".concat(apiUrls.commerceLeadCaptureApi, "/").concat(COMMERCE_LEAD_SUBMIT_PATH), {
            method: 'POST',
            body: JSON.stringify(payload)
          });
        case 1:
          response = _context5.sent;
          _logger.default.info('Lead submitted successfully via commerce-lead-capture-service', {
            externalSystemId: payload.externalSystemId,
            customerId: payload.customerId
          });
          return _context5.abrupt("return", response);
        case 2:
          _context5.prev = 2;
          _logger.default.info('Submitting lead to GUI API', {
            externalSystemId: payload.externalSystemId,
            customerId: payload.customerId
          });
          _context5.next = 3;
          return (0, _utils.makeApiCall)("".concat(apiUrls.guiApi, "/forms/lmapi/submit"), {
            method: 'POST',
            headers: {
              'X-App-Key': _config.hookConfig.appKey
            },
            body: JSON.stringify(payload)
          });
        case 3:
          _response = _context5.sent;
          _logger.default.info('Lead submitted successfully', {
            externalSystemId: payload.externalSystemId,
            customerId: payload.customerId
          });
          return _context5.abrupt("return", _response);
        case 4:
          _context5.prev = 4;
          _t2 = _context5["catch"](2);
          if (!((_submitError$message = _t2.message) !== null && _submitError$message !== void 0 && _submitError$message.includes('HTTP 400'))) {
            _context5.next = 5;
            break;
          }
          _logger.default.info('Lead submission returned 400, treating as success', {
            externalSystemId: payload.externalSystemId,
            customerId: payload.customerId
          });
          return _context5.abrupt("return", null);
        case 5:
          _logger.default.error('Lead submission failed', _t2);
          throw _t2;
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[2, 4]]);
  }));
  return _submitLeadToAPI.apply(this, arguments);
}
function useSubmitDifyLead(params) {
  var customerId = params.customerId,
    source = params.source,
    productIntent = params.productIntent,
    sourceApp = params.sourceApp,
    contactInfo = params.contactInfo,
    _params$businessName = params.businessName,
    businessName = _params$businessName === void 0 ? null : _params$businessName,
    _params$businessWebsi = params.businessWebsite,
    businessWebsite = _params$businessWebsi === void 0 ? null : _params$businessWebsi,
    _params$includeLeadSc = params.includeLeadScore,
    includeLeadScore = _params$includeLeadSc === void 0 ? false : _params$includeLeadSc,
    _params$smsConsent = params.smsConsent,
    smsConsent = _params$smsConsent === void 0 ? false : _params$smsConsent,
    _params$leadSource = params.leadSource,
    leadSource = _params$leadSource === void 0 ? 'In Product Request' : _params$leadSource,
    providedExternalSystemId = params.externalSystemId,
    _params$recordOwnerEm = params.recordOwnerEmail,
    recordOwnerEmail = _params$recordOwnerEm === void 0 ? _config.hookConfig.defaultRecordOwnerEmail : _params$recordOwnerEm,
    _params$commerceLeadS = params.commerceLeadSubmissionEnabled,
    commerceLeadSubmissionEnabled = _params$commerceLeadS === void 0 ? false : _params$commerceLeadS;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isSuccess = _useState4[0],
    setIsSuccess = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isError = _useState6[0],
    setIsError = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];

  // NOTE: generate externalSystemId once
  var _useState9 = (0, _react.useState)(function () {
      return providedExternalSystemId || crypto.randomUUID();
    }),
    _useState0 = (0, _slicedToArray2.default)(_useState9, 1),
    externalSystemId = _useState0[0];
  var apiUrls = (0, _utils.getApiUrls)();

  /**
   * Internal handler for lead submission
   */
  var handleSubmitLead = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, contact, leadScore, payload;
      return _regenerator.default.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _logger.default.info('Starting lead submission', {
              customerId: customerId,
              source: source,
              sourceApp: sourceApp,
              externalSystemId: externalSystemId,
              hasContactInfo: !!contactInfo,
              includeLeadScore: includeLeadScore
            });

            // Step 1 & 2: Fetch customer contact and lead score in parallel
            _context.next = 1;
            return Promise.all([contactInfo || fetchCustomerContact(customerId, apiUrls), includeLeadScore ? fetchLeadScore(leadSource, apiUrls) : Promise.resolve(null)]);
          case 1:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
            contact = _yield$Promise$all2[0];
            leadScore = _yield$Promise$all2[1];
            // Step 3: Build the complete payload
            payload = buildLeadPayload(contact, leadScore, {
              customerId: customerId,
              source: source,
              productIntent: productIntent,
              businessName: businessName,
              businessWebsite: businessWebsite,
              smsConsent: smsConsent,
              sourceApp: sourceApp,
              leadSource: leadSource,
              externalSystemId: externalSystemId,
              recordOwnerEmail: recordOwnerEmail
            }); // Step 4: Submit to the selected lead-capture backend
            _context.next = 2;
            return submitLeadToAPI(payload, apiUrls, commerceLeadSubmissionEnabled);
          case 2:
            _logger.default.info('Lead submission completed successfully', {
              externalSystemId: externalSystemId,
              customerId: customerId
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmitLead() {
      return _ref.apply(this, arguments);
    };
  }();
  var submitLead = (0, _react.useCallback)(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var _t;
    return _regenerator.default.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          setIsLoading(true);
          setIsError(false);
          setError(null);
          setIsSuccess(false);
          _context2.next = 1;
          return handleSubmitLead();
        case 1:
          setIsSuccess(true);
          _context2.next = 3;
          break;
        case 2:
          _context2.prev = 2;
          _t = _context2["catch"](0);
          _logger.default.error('Lead submission failed', _t);
          setIsError(true);
          setError(_t instanceof Error ? _t : new Error(String(_t)));
        case 3:
          _context2.prev = 3;
          setIsLoading(false);
          return _context2.finish(3);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 2, 3, 4]]);
  })), [customerId, source, productIntent, sourceApp, contactInfo, businessName, businessWebsite, includeLeadScore, smsConsent, leadSource, externalSystemId, recordOwnerEmail, apiUrls, commerceLeadSubmissionEnabled]);
  return {
    submitLead: submitLead,
    isLoading: isLoading,
    isSuccess: isSuccess,
    isError: isError,
    error: error,
    externalSystemId: externalSystemId
  };
}